'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var utilities = require('@brandfolder/utilities');
var React = require('react');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseLink = /*#__PURE__*/ React.forwardRef((props, ref)=>{
    const { 'aria-disabled': ariaDisabled , children , disabled , href , loading , onClick , ...otherProps } = props;
    const isDisabled = utilities.getBooleanishTruthy(ariaDisabled) || disabled || undefined;
    return /*#__PURE__*/ React__default.default.createElement("a", _extends({}, otherProps, {
        "aria-disabled": isDisabled,
        href: !isDisabled && !loading ? href : undefined,
        onClick: !isDisabled && !loading ? onClick : undefined,
        ref: ref
    }), children);
});

exports.BaseLink = BaseLink;
//# sourceMappingURL=base-link.js.map
